var map = {
	"./gallery-wip-pommel-neck_00.jpg": 2828,
	"./gallery-wip-pommel-neck_01.jpg": 2829,
	"./gallery-wip-pommel-neck_02.jpg": 2830,
	"./gallery-wip-pommel-neck_03.jpg": 2831,
	"./gallery_00.jpg": 2832,
	"./gallery_01.jpg": 2833,
	"./gallery_02.jpg": 2834,
	"./gallery_03.jpg": 2835
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2827;